/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingConsentDto } from '../../models/marketing-consent-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface MarketingConsentControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo?: number;

/**
 * 마케팅 동의 여부
 */
  isAgreed?: boolean;

/**
 * 브랜드
 */
  brandType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function marketingConsentControllerSearchV1(http: HttpClient, rootUrl: string, params?: MarketingConsentControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('isAgreed', params.isAgreed, {});
    rb.query('brandType', params.brandType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<MarketingConsentDto>;
      }>;
    })
  );
}

marketingConsentControllerSearchV1.PATH = '/api/v1/marketing-consent/search';
